import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import {
  matchSupportChatToRoute,
  whenSupportChatReady,
} from '../../utils/chat';
import './assets/css/support_chat.css';

function HubspotLoader() {
  const { pathname } = useLocation();
  const pathnameRef = useRef(pathname);

  // HubSpot can take a while to get ready, and the visitor may have moved on by
  // then, so the widget is matched to whichever route is current at the time.
  useEffect(() => {
    if (document.getElementById('hs-script-loader')) {
      return;
    }
    window.hsConversationsSettings = { loadImmediately: false };
    whenSupportChatReady(() => {
      window.HubSpotConversations.on('widgetLoaded', () =>
        matchSupportChatToRoute(pathnameRef.current)
      );
      matchSupportChatToRoute(pathnameRef.current);
    });

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'hs-script-loader';
    script.async = true;
    script.defer = true;
    script.src = '//js.hs-scripts.com/145784441.js';
    script.onerror = () => {
      console.warn('Failed to load HubSpot script');
    };
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    pathnameRef.current = pathname;
    if (window.HubSpotConversations) {
      whenSupportChatReady(() => matchSupportChatToRoute(pathname));
    }
  }, [pathname]);

  return null;
}

export default HubspotLoader;
